import { Flex, Icon, Typography } from '@aloft/toolkit-sui';

import { FormProvider, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { AddressInput } from '../../AddressInput/AddressInput.js';
import { AddressInputErrors } from '../../AddressInput/AddressInputErrors.js';
import { EditPropertyDetailsForm } from './types.js';
import { MLSInput } from '../../MLSInput/MLSInput.js';

type EditPropertyDetailsModalProps = {
  form: UseFormReturn<z.input<EditPropertyDetailsForm>, unknown, z.infer<EditPropertyDetailsForm>>;
} & { addressLabel: string; showWarning: boolean; lockAddress: boolean };

export const EditPropertyDetailsModalContent = ({
  form,
  addressLabel,
  showWarning,
  lockAddress,
}: EditPropertyDetailsModalProps) => (
  <Flex width="100%" height="100%" gap={4} flexDirection="column">
    <FormProvider {...form}>
      <AddressInput addressLabel={addressLabel} lockAddress={lockAddress} />
    </FormProvider>
    <Flex gap={2}>
      <FormProvider {...form}>
        <MLSInput />
      </FormProvider>
    </Flex>
    {showWarning && (
      <Flex alignItems="center" gap={1} marginBottom="1rem" marginLeft=".75rem">
        <Icon icon={'warning'} size="lg" />
        <Typography>Changing the MLS info may overwrite existing data for this property.</Typography>
      </Flex>
    )}
    <FormProvider {...form}>
      <AddressInputErrors />
    </FormProvider>
  </Flex>
);
